import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "tabs-bar" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = {
  key: 0,
  class: "report-back-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectSummarySection = _resolveComponent("ProjectSummarySection")!
  const _component_ProjectFilesSection = _resolveComponent("ProjectFilesSection")!
  const _component_ProjectReportsSection = _resolveComponent("ProjectReportsSection")!
  const _component_SubmissionView = _resolveComponent("SubmissionView")!
  const _component_SafetyDocumentView = _resolveComponent("SafetyDocumentView")!
  const _component_SubmissionFormView = _resolveComponent("SubmissionFormView")!
  const _component_SafetyDialogFormView = _resolveComponent("SafetyDialogFormView")!
  const _component_SafetyOccurrenceFormView = _resolveComponent("SafetyOccurrenceFormView")!
  const _component_ProjectGanttSection = _resolveComponent("ProjectGanttSection")!
  const _component_ProjectPendenciasSection = _resolveComponent("ProjectPendenciasSection")!
  const _component_ProjectAttendanceSection = _resolveComponent("ProjectAttendanceSection")!
  const _component_ProjectWarehouseSection = _resolveComponent("ProjectWarehouseSection")!
  const _component_ProjectTeamsSection = _resolveComponent("ProjectTeamsSection")!
  const _component_ProjectTicketsSection = _resolveComponent("ProjectTicketsSection")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", { embedded: _ctx.embedded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'summary' }]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'summary'))
          }, "Resumo", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'gantt' }]),
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'gantt'))
          }, "Planejamento", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'reports' }]),
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'reports'))
          }, "Relatórios", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'files' }]),
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'files'))
          }, "Arquivos", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'attendance' }]),
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'attendance'))
          }, "Presenças", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'teams' }]),
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'teams'))
          }, "Equipes", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.tab === 'pendencias' }]),
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'pendencias'))
          }, "Pendências", 2)
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "tabs-actions",
          id: "gantt-toolbar-slot"
        }, null, -1))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-body", { 'tab-body--gantt': _ctx.tab === 'gantt' }])
      }, [
        (_ctx.tab === 'summary')
          ? (_openBlock(), _createBlock(_component_ProjectSummarySection, {
              key: 0,
              loading: _ctx.initialLoading,
              "project-name": _ctx.projectName,
              progress: _ctx.summaryProgress,
              "gantt-rows": _ctx.ganttRows,
              "project-reports": _ctx.projectReports,
              "project-reservations": _ctx.projectReservations,
              "project-tickets": _ctx.projectTickets,
              "assignable-users": _ctx.assignableUsers,
              "warehouse-items": _ctx.warehouseItems,
              onNavigate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tab = $event))
            }, null, 8, ["loading", "project-name", "progress", "gantt-rows", "project-reports", "project-reservations", "project-tickets", "assignable-users", "warehouse-items"]))
          : (_ctx.tab === 'files')
            ? (_openBlock(), _createBlock(_component_ProjectFilesSection, {
                key: 1,
                "project-id": _ctx.resolvedProjectId,
                "access-mode": _ctx.accessMode
              }, null, 8, ["project-id", "access-mode"]))
            : (_ctx.tab === 'reports')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.reportSubview !== 'list')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("button", {
                          class: "report-back-btn",
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeReportSubview && _ctx.closeReportSubview(...args)))
                        }, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1),
                          _createTextVNode(" Voltar à lista ", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.reportSubview === 'list')
                    ? (_openBlock(), _createBlock(_component_ProjectReportsSection, {
                        key: 1,
                        loading: _ctx.initialLoading,
                        items: _ctx.projectReports,
                        "access-mode": _ctx.accessMode,
                        onViewReport: _ctx.openReportView,
                        onEditReport: _ctx.openReportEdit,
                        onDeleteReports: _ctx.deleteProjectReports
                      }, null, 8, ["loading", "items", "access-mode", "onViewReport", "onEditReport", "onDeleteReports"]))
                    : (_ctx.reportSubview === 'view' && _ctx.activeReportItem?.category === 'relatorio')
                      ? (_openBlock(), _createBlock(_component_SubmissionView, {
                          key: 2,
                          embedded: true,
                          "submission-id": _ctx.activeReportId,
                          onBack: _ctx.closeReportSubview,
                          onEdit: _ctx.openReportEdit
                        }, null, 8, ["submission-id", "onBack", "onEdit"]))
                      : (_ctx.reportSubview === 'view' && _ctx.activeReportItem)
                        ? (_openBlock(), _createBlock(_component_SafetyDocumentView, {
                            key: 3,
                            embedded: true,
                            "submission-id": _ctx.activeReportId,
                            onBack: _ctx.closeReportSubview,
                            onEdit: _ctx.openReportEdit
                          }, null, 8, ["submission-id", "onBack", "onEdit"]))
                        : (_ctx.reportSubview === 'edit' && _ctx.activeReportItem?.category === 'relatorio')
                          ? (_openBlock(), _createBlock(_component_SubmissionFormView, {
                              key: 4,
                              embedded: true,
                              "submission-id": _ctx.activeReportId,
                              onDone: _ctx.closeReportSubviewAndRefresh,
                              onCancel: _ctx.closeReportSubview
                            }, null, 8, ["submission-id", "onDone", "onCancel"]))
                          : (_ctx.reportSubview === 'edit' && _ctx.activeReportItem?.category === 'dialogo')
                            ? (_openBlock(), _createBlock(_component_SafetyDialogFormView, {
                                key: 5,
                                embedded: true,
                                "submission-id": _ctx.activeReportId,
                                onDone: _ctx.closeReportSubviewAndRefresh,
                                onCancel: _ctx.closeReportSubview
                              }, null, 8, ["submission-id", "onDone", "onCancel"]))
                            : (_ctx.reportSubview === 'edit' && _ctx.activeReportItem?.category === 'ocorrido')
                              ? (_openBlock(), _createBlock(_component_SafetyOccurrenceFormView, {
                                  key: 6,
                                  embedded: true,
                                  "submission-id": _ctx.activeReportId,
                                  onDone: _ctx.closeReportSubviewAndRefresh,
                                  onCancel: _ctx.closeReportSubview
                                }, null, 8, ["submission-id", "onDone", "onCancel"]))
                              : (_ctx.reportSubview === 'edit' && _ctx.activeReportItem)
                                ? (_openBlock(), _createBlock(_component_SafetyDocumentView, {
                                    key: 7,
                                    embedded: true,
                                    "submission-id": _ctx.activeReportId,
                                    onBack: _ctx.closeReportSubview,
                                    onEdit: _ctx.closeReportSubview
                                  }, null, 8, ["submission-id", "onBack", "onEdit"]))
                                : _createCommentVNode("", true)
                ], 64))
              : (_ctx.tab === 'gantt')
                ? (_openBlock(), _createBlock(_component_ProjectGanttSection, {
                    key: 3,
                    loading: _ctx.initialLoading,
                    rows: _ctx.ganttRows,
                    tasks: _ctx.tasks,
                    "assignee-name": _ctx.assigneeName,
                    "assignable-users": _ctx.assignableUsers,
                    "warehouse-items": _ctx.warehouseItems,
                    "access-mode": _ctx.accessMode,
                    "blocked-dates": _ctx.blockedDates,
                    "project-id": _ctx.resolvedProjectId,
                    "on-save-task": _ctx.saveTaskById,
                    "on-import-tasks": _ctx.importTasks,
                    "on-update-progress": _ctx.updateProgress,
                    "on-save-blocked-dates": _ctx.saveBlockedDates,
                    "on-delete-task": _ctx.deleteTask,
                    "on-delete-progress": _ctx.deleteProgressUpdate,
                    "project-name": _ctx.projectName,
                    "system-name": _ctx.systemName,
                    "logo-text": _ctx.logoText,
                    "is-analyst": _ctx.isAnalyst,
                    "open-new-task": _ctx.openNewTaskFlag,
                    groups: _ctx.taskGroups,
                    "on-save-group": _ctx.saveGroup,
                    "on-delete-group": _ctx.deleteGroup
                  }, null, 8, ["loading", "rows", "tasks", "assignee-name", "assignable-users", "warehouse-items", "access-mode", "blocked-dates", "project-id", "on-save-task", "on-import-tasks", "on-update-progress", "on-save-blocked-dates", "on-delete-task", "on-delete-progress", "project-name", "system-name", "logo-text", "is-analyst", "open-new-task", "groups", "on-save-group", "on-delete-group"]))
                : (_ctx.tab === 'pendencias')
                  ? (_openBlock(), _createBlock(_component_ProjectPendenciasSection, {
                      key: 4,
                      "project-id": _ctx.resolvedProjectId,
                      "project-name": _ctx.projectName,
                      "access-mode": _ctx.accessMode,
                      tasks: _ctx.ganttRows,
                      "open-create": _ctx.pendenciasOpenCreate
                    }, null, 8, ["project-id", "project-name", "access-mode", "tasks", "open-create"]))
                  : (_ctx.tab === 'attendance')
                    ? (_openBlock(), _createBlock(_component_ProjectAttendanceSection, {
                        key: 5,
                        "project-id": _ctx.resolvedProjectId,
                        "access-mode": _ctx.accessMode
                      }, null, 8, ["project-id", "access-mode"]))
                    : (_ctx.tab === 'warehouse')
                      ? (_openBlock(), _createBlock(_component_ProjectWarehouseSection, {
                          key: 6,
                          reservations: _ctx.projectReservations,
                          "item-name": _ctx.itemName
                        }, null, 8, ["reservations", "item-name"]))
                      : (_ctx.tab === 'teams')
                        ? (_openBlock(), _createBlock(_component_ProjectTeamsSection, {
                            key: 7,
                            "project-id": _ctx.resolvedProjectId,
                            "access-mode": _ctx.accessMode,
                            "all-users": _ctx.assignableUsers
                          }, null, 8, ["project-id", "access-mode", "all-users"]))
                        : (_openBlock(), _createBlock(_component_ProjectTicketsSection, {
                            key: 8,
                            "show-form": _ctx.showTicketForm,
                            form: _ctx.ticketForm,
                            items: _ctx.projectTickets,
                            "ticket-approval-status": _ctx.ticketApprovalStatus,
                            "on-toggle-form": _ctx.toggleTicketForm,
                            "on-create": _ctx.createTicket
                          }, null, 8, ["show-form", "form", "items", "ticket-approval-status", "on-toggle-form", "on-create"]))
      ], 2)
    ])
  ], 2))
}